import { Navigate } from "react-router-dom";
import { useContext } from "react";

import { AuthContext } from "../contexts/AuthContext";
import useLocalStorage from "../hooks/useLocalStorage";

const PrivateRoute = ({ element }: any) => {
  const { isAuthenticated, logout } = useContext(AuthContext);
  const [company] = useLocalStorage("company");

  if (isAuthenticated) {
    if (company == null) {
      logout();
    }
    return element;
  } else {
    return <Navigate to='/login' replace />;
  }
};

export default PrivateRoute;
